<template>
  <div class="bodymain">
    <div class="title">
      <el-button type="primary" @click="openmenu" :icon="isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
        size="small"></el-button>
      <span class="titlefront">询问管理 /</span>
      笔录详情
    </div>
    <div class="headermain">
      <span class="headerleft">{{ form.recordPO.caseName }}</span>
      <span class="headermid">{{ innerText }}</span>
      <div class="headermid">
        <img src="../images/time.png" class="timeimg" />
        {{ myHours }} : {{ myMinutes }} :{{ mySeconds }}
      </div>
      <div>
        <el-button type="primary" @click="sendcode">短信签名</el-button>
      </div>
    </div>

    <div class="bodycontainer">
      <el-row>
        <el-col :span="9">
          <div class="grid-content bg-purple bodyleft">
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item title="笔录基本信息" name="1">
                <template slot="title">
                  <div class="bodyleftheader">
                    <span class="contenttitle">笔录基本信息</span>
                  </div>
                </template>
                <div class="contline">
                  <span class="contentkey">案件名称：</span>
                  <el-input v-model="form.recordPO.caseName" placeholder="请输入案件名称"></el-input>
                </div>
                <div class="contline">
                  <span class="contentkey">询问场景：</span>
                  {{ form.recordPO.inquiryScene }}
                </div>
                <div class="contline">
                  <span class="contentkey">案发单位：</span>
                  <el-input v-model="form.recordPO.happenPlace" placeholder="请输入案发单位"></el-input>
                </div>
                <div class="contline">
                  <span class="contentkey">询问地点：</span>
                  <el-input v-model="form.recordPO.inquiryPlace" placeholder="请输入询问地点"></el-input>
                </div>
                <div class="contline">
                  <span class="contentkey">开始时间：</span>
                  {{ form.recordPO.inquiryBegin }}
                  <!-- <el-date-picker
                v-model="form.recordPO.inquiryBegin"
                style="width:100%"
                type="datetime"
                disabled
                placeholder="选择日期时间"
                  ></el-date-picker>-->
                </div>
                <div class="contline">
                  <span class="contentkey">结束时间：</span>
                  {{ form.recordPO.inquiryEnd || "未结束" }}
                  <!-- <el-date-picker
                v-model="form.recordPO.inquiryEnd"
                disabled
                type="datetime"
                placeholder="选择日期时间"
                style="width:100%"
                  ></el-date-picker>-->
                </div>
              </el-collapse-item>
              <el-collapse-item title="被询问人信息" name="2">
                <template slot="title">
                  <div class="bodyleftheader">
                    <span class="contenttitle">被询问人信息</span>
                  </div>
                </template>
                <div class="contline">
                  <span class="titlewidths">
                    <span class="dian">*</span>姓名：
                  </span>
                  <el-input v-model="form.recordPO.respondentName" placeholder="姓名"
                    style="width:100px;margin-right:10px;height:40px"></el-input>
                  <span class="titlewidthr">
                    <span class="dian">*</span>年龄：
                  </span>
                  <el-input v-model="form.recordPO.respondentAge" style="width:100px;margin-right:10px;height:40px"
                    placeholder="年龄"></el-input>
                </div>
                <div class="contline">
                  <span class="titlewidths">
                    <span class="dian">*</span>民族：
                  </span>
                  <el-input v-model="form.recordPO.respondentNation" placeholder="民族"
                    style="width:100px;margin-right:10px;height:40px"></el-input>
                  <span class="titlewidthr">
                    <span class="dian">*</span>性别：
                  </span>
                  <el-radio v-model="form.recordPO.respondentGender" label="男">男</el-radio>
                  <el-radio v-model="form.recordPO.respondentGender" label="女">女</el-radio>
                  <!-- <el-input
                v-model="form.recordPO.respondentGender"
                placeholder="性别"
                style="width:100px;margin-right:10px;height:40px"
                  ></el-input>-->
                </div>
                <div class="contline">
                  <span class="titlewidths">职业：</span>
                  <el-input v-model="form.recordPO.respondentOccupation" placeholder="职业"
                    style="width:100px;margin-right:10px;height:40px"></el-input>
                  <span class="titlewidthr">
                    <span class="dian">*</span>文化程度：
                  </span>
                  <el-select placeholder="请选择文化程度" style="width:130px;margin-right:10px;height:40px"
                    v-model="form.recordPO.respondentEdu">
                    <el-option v-for="item in edulist" :key="item.eduName" :label="item.eduName"
                      :value="item.eduName"></el-option>
                  </el-select>
                </div>
                <div class="contline">
                  <span class="titlewidths">
                    <span class="dian">*</span>询问次数：
                  </span>
                  <el-select placeholder="请选择询问次数" style="width:100px;margin-right:10px;height:40px"
                    v-model="form.recordPO.respondTimes">
                    <el-option v-for="item in numlist" :key="item.num" :label="item.num" :value="item.num"></el-option>
                  </el-select>
                  <span class="titlewidthr">
                    <span class="dian">*</span>被询问人类型：
                  </span>
                  <el-select placeholder="请选择被询问人类型" style="width:130px;margin-right:10px;height:40px"
                    v-model="form.recordPO.respondentType">
                    <el-option v-for="item in peoplelist" :key="item.peopletype" :label="item.peopletype"
                      :value="item.peopletype"></el-option>
                  </el-select>
                </div>
                <div class="contline">
                  <span class="titlewidth">
                    <span class="dian">*</span>手机号：
                  </span>
                  <el-input v-model="form.recordPO.respondentPhone" placeholder="请输入手机号"></el-input>
                </div>
                <div class="contline">
                  <span class="titlewidth">
                    <span class="dian">*</span>证件类型：
                  </span>
                  <el-select placeholder="请选择证件类型" v-model="form.recordPO.respondentCertType" style="width:100%">
                    <el-option v-for="item in cardlist" :key="item.cardtype" :label="item.cardtype"
                      :value="item.cardtype"></el-option>
                  </el-select>
                </div>
                <div class="contline">
                  <span class="titlewidth">
                    <span class="dian">*</span>证件号：
                  </span>
                  <el-input v-model="form.recordPO.respondentCertNo" placeholder="请输入证件号"></el-input>
                </div>
                <div class="contline">
                  <span class="titlewidth">
                    <span class="dian">*</span>户籍地：
                  </span>
                  <el-input v-model="form.recordPO.respondentOrigin" placeholder="请输入户籍地"></el-input>
                </div>
                <div class="contline">
                  <span class="titlewidth">
                    <span class="dian">*</span>现居地：
                  </span>
                  <el-input v-model="form.recordPO.respondentAddress" placeholder="请输入现居地"></el-input>
                </div>
                <div class="contline">
                  <span class="titlewidth">工作单位：</span>
                  <el-input v-model="form.recordPO.respondentWorkUnit" placeholder="请输入工作单位"></el-input>
                </div>
              </el-collapse-item>

              <el-collapse-item title="被询问人信息" name="3">
                <template slot="title">
                  <div class="bodyleftheader">
                    <span class="contenttitle">询问人信息</span>
                  </div>
                </template>
                <div class="askcontainer">
                  <div class="askmain" v-if="datalist.mainInquirer">
                    <div class="askheader">主办询问人</div>
                    <div class="askline">姓名：{{ datalist.mainInquirer.nickname }}</div>
                    <div class="askline">执法证号：{{ datalist.mainInquirer.certNo }}</div>
                    <div class="askline">手机号：{{ datalist.mainInquirer.phone }}</div>
                  </div>
                  <div class="askmain" v-if="datalist.auxiliaryInquirer">
                    <div class="askheader">辅办询问人</div>
                    <div class="askline">姓名：{{ datalist.auxiliaryInquirer.nickname }}</div>
                    <div class="askline">执法证号：{{ datalist.auxiliaryInquirer.certNo }}</div>
                    <div class="askline">手机号：{{ datalist.auxiliaryInquirer.phone }}</div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="笔录视频" name="4">
                <template slot="title">
                  <div class="bodyleftheader">
                    <span class="contenttitle">笔录视频</span>
                  </div>
                </template>
                <div class="askcontenthead">
                  <div class="qarecord">
                    <!-- 对话记录 -->
                  </div>
                  <div class="videomain">
                    <Video ref="video" :homeInfo="form.recordPO.respondentPhone" @showButton="showButton"
                      :endType="endType" :begdis="begdis" />
                  </div>
                </div>
                <el-button type="primary" @click="beginrecord" :disabled="begdis" class="beginvideo"
                  v-if="showbtn">开始录制</el-button>
                <el-button type="primary" @click="endrecords" :disabled="enddis" class="beginvideo"
                  v-if="showbtn">结束录制</el-button>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="grid-content bg-purple-light bodyright">
            <div class="bodyrightheader">
              <div class="duihua">
                对话记录
                <el-tooltip class="item" effect="dark"
                  content="现在依法对你进行 询问，你应当如实回答我们的询问并协助调查，不得提供虚假证言，不得伪造、隐匿、毁灭证据，否则将承担法律责任。你有权对有关情况进行陈述和申 辩，有权就询问事项自行提供书面材料，有权拒绝回答与案件无关的问题，有 权核对询问笔录，对笔录记载有误或者遗漏之处提出更正或者补充意见，有权对 办案人员有下列情形之一的申请回避： （1）系 本案当事人或当事人的近亲属；（2） 与本案有直接利害关系；（3）与本案当事人有其他关系，可能影响案件公正处 理的。如果你回答的内容涉及国家机密、商业秘密或者个人隐私，本机关将予 以保密。以上权利、义务告知，你是否听明白?"
                  placement="bottom">
                  <span class="tip">
                    <img src="../images/tishi.png" class="tipimg" />
                    提示
                  </span>
                </el-tooltip>
              </div>
              <div>
                <el-button type="primary" @click="savebtn">
                  <i class="el-icon-upload"></i>
                  保存
                </el-button>
                <el-button type="primary" @click="previewbtn">
                  <i class="el-icon-printer"></i>
                  预览
                </el-button>
                <el-button type="primary" @click="endrecord">
                  <i class="el-icon-s-release"></i>
                  结束
                </el-button>
              </div>
            </div>
            <div class="askcontentmain">
              <el-form :model="form" hide-required-asterisk>
                <div v-for="(item, index) in form.questions" :key="index" class="qaBox">
                  <div class="askqueline">
                    <el-form-item :prop="'questions.' + index + '.content'" :rules="{
                      required: true, message: '提问内容不能为空', trigger: 'blur',
                    }">
                      <template slot="label">
                        <span class="asktype">
                          问
                          <img src="../images/toup.png" class="toupimg" @click="toupbutton(item, index)"
                            v-if="index !== 0" />
                        </span>
                      </template>
                      <el-input type="textarea" v-model="item.content" placeholder="问" style="font-size:18px"
                        :autosize="{ minRows: 1, maxRows: 5 }"></el-input>
                      <!-- <el-input v-model="item.content" placeholder="问" style="font-size:18px" /> -->
                    </el-form-item>
                    <img src="../images/shan.png" class="adddelimg" @click="deletebutton(item)"
                      v-if="form.questions.length > 1 && index !== (form.questions.length - 1)" />
                    <!-- <el-button
                      type="primary"
                      class="deletebtn"
                    
                    >
                  
                    </el-button>-->
                  </div>
                  <div class="askqueline">
                    <el-form-item :prop="'questions.' + index + '.answer'" :rules="{
                      required: true, message: '回答内容不能为空', trigger: 'blur',
                    }">
                      <template slot="label">
                        <span class="quetype">
                          答
                          <img src="../images/todown.png" class="todownimg" @click="todownbutton(item, index)"
                            v-if="index !== (form.questions.length - 1)" />
                        </span>
                      </template>
                      <el-input type="textarea" v-model="item.answer" placeholder="答" style="font-size:18px"
                        :autosize="{ minRows: 1, maxRows: 5 }"></el-input>
                    </el-form-item>
                    <img src="../images/jia.png" class="adddelimg" @click="addbutton(item)"
                      v-if="index !== (form.questions.length - 1)" />
                    <!-- <el-button type="primary" class="addbtn">新增</el-button> -->
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import Video from "./Home.vue";
import {
  findrecord,
  changerecord,
  sendsmsforSign,
  previewpdf,
  startrecording,
  stoprecording,
  setFinishrecord
} from "../axios/api.js";

export default {
  components: { Video },
  beforeRouteLeave(to, from, next) {
    console.log(to, from, next);
    if (this.enddis === false) {
      return this.$message.error('笔录视频未保存，请保存视频')
    } else {
      this.$confirm("正在离开本页面，本页面内所有未保存数据都会丢失", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 正常跳转
          next();
        })
        .catch(() => {
          localStorage.setItem("activetab", "/record/ask");
          // window.location.href = "/record/ask";
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          this.reload();
          window.history.go(1);
        });
    }
    // localStorage.setItem("formdata", JSON.stringify(this.form.recordPO));
    // 这里需要elementui的支持，如果使用其他界面组件自行替换即可

  },
  data() {
    return {
      value1: "",
      routerAlive: true,
      isCollapse: true,
      innerText: "",
      value2: "",
      activeNames: ["1", "2", "3", "4"],
      menuname: "",
      datalist: {},
      currentTime: 0,
      casedeid: "",
      begdis: false,
      enddis: true,
      flag: false,
      edulist: [
        {
          id: 1,
          eduName: "小学及以下"
        },
        {
          id: 2,
          eduName: "中学"
        },
        {
          id: 3,
          eduName: "大专"
        },
        {
          id: 4,
          eduName: "本科"
        },
        {
          id: 5,
          eduName: "研究生及以上"
        }
      ],
      cardlist: [
        {
          id: 1,
          cardtype: "身份证"
        },
        {
          id: 2,
          cardtype: "驾驶证"
        },
        {
          id: 3,
          cardtype: "护照"
        },
        {
          id: 4,
          cardtype: "台胞证"
        }
      ],
      numlist: [
        {
          id: 1,
          num: 1
        },
        {
          id: 2,
          num: 2
        },
        {
          id: 3,
          num: 3
        },
        {
          id: 4,
          num: 4
        },
        {
          id: 5,
          num: 5
        }
      ],

      peoplelist: [
        {
          id: 1,
          peopletype: "受委托人"
        },
        {
          id: 2,
          peopletype: "违法嫌疑人"
        },
        {
          id: 3,
          peopletype: "证人"
        },
        {
          id: 4,
          peopletype: "受害者"
        }
      ],

      timeObj: null, // 时间对象,下方会用到
      myHours: "00", // 我定义来接收计算出来的 小时 的
      myMinutes: "00", // 我定义来接收计算出来的 分钟 的
      mySeconds: "00", // 我定义来接收计算出来的 秒钟 的
      askForm: {
        askList: [
        ]
      },
      form: {
        questions: [
        ],
        recordPO: {
          auxiliaryInquirerId: null,
          caseName: null,
          caseTypeId: null,
          createTime: null,
          deptId: null,
          happenPlace: null,
          id: 0,
          inquiryBegin: null,
          inquiryEnd: null,
          inquiryPlace: null,
          inquiryScene: null,
          mainInquirerId: null,
          respondTimes: 1,
          respondentAddress: null,
          respondentAge: 18,
          respondentCertNo: null,
          respondentCertType: null,
          respondentEdu: "本科",
          respondentGender: null,
          respondentName: null,
          respondentNation: "汉族",
          respondentOccupation: null,
          respondentOrigin: null,
          respondentPhone: null,
          respondentType: null,
          respondentWorkUnit: null,
          updateTime: null
        }
      },
      showbtn: false,
      endType: false
    };
  },

  methods: {
    testTimer() {
      this.timeFunction();
      setInterval(() => {
        this.timeFunction();
      }, 1000);
    },

    //重新加载的方法
    reload() {
      console.log(111);
      this.routerAlive = false;
      this.$nextTick(function () {
        this.routerAlive = true;
      });
    },

    //向上排序
    toupbutton(item, index) {
      var arr = this.form.questions;
      console.log(index - 1);
      var sort = item.sort;
      for (var i in arr) {
        // console.log();
        if (Number(i) === Number(index)) {
          console.log(arr[i].sort);
          arr[i].sort = arr[Number(i - 1)].sort;
          arr[Number(i - 1)].sort = sort;
        }
      }
      this.form.questions = arr.sort(function (a, b) {
        return a.sort < b.sort ? -1 : 1;
      });
    },

    //向下排序
    todownbutton(item, index) {
      var arr = this.form.questions;
      console.log(Number(index + 1));
      console.log(item.sort);
      var sort = item.sort;
      for (var i in arr) {
        // console.log();
        if (Number(i) === Number(index)) {
          console.log(arr[i].sort);
          console.log(arr[index + 1]);
          // console.log(arr[Number(i + 1)].sort);
          arr[Number(i)].sort = arr[Number(index + 1)].sort;
          arr[Number(index + 1)].sort = sort;
        }
      }
      this.form.questions = arr.sort(function (a, b) {
        return a.sort < b.sort ? -1 : 1;
      });
    },

    //发送短信签名
    sendcode() {
      const params = {
        // link: decodeURIComponent(
        //   `https://record.terabits.cn/pdf?caseid=${localStorage.getItem(
        //     "caseid"
        //   )}，`
        // ),
        phone: this.form.recordPO.respondentPhone,
        caseId: String(localStorage.getItem(
          "caseid"
        )),
        // type:'sign'
      };
      if (this.form.recordPO.respondentPhone) {
        sendsmsforSign(params).then(res => {
          if (res && res.code === 200) {
            MessageBox.confirm(`【杭州拱墅疾病预防控制中心】笔录已完成，请打开以下链接：https://record.terabits.cn/pdf?caseid=${String(localStorage.getItem(
          "caseid"
        ))}，核对内容并确认签字`, '短信内容', {
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            })
            this.$message.success("短信发送成功");
          }
        });
      } else {
        this.$message.error("请输入被询问人手机号码");
      }
    },

    //点击预览
    previewbtn() {
      this.flag = true;
      this.saverecord('pdf');
    },

    //点击保存
    savebtn() {
      // console.log(111);
      this.form.recordPO.status = 1;
      this.saverecord('save');
    },

    saverecord(val) {
      var telrule = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      var regIdCard = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;

      if (!this.form.recordPO.caseName) {
        this.$message.error("请输入案件名称");
      } else if (!this.form.recordPO.happenPlace) {
        this.$message.error("请输入案件案发单位");
      } else if (!this.form.recordPO.inquiryPlace) {
        this.$message.error("请输入案件询问地点");
      } else if (!this.form.recordPO.respondentName) {
        this.$message.error("请输入被询问人姓名");
      } else if (!this.form.recordPO.respondentAge) {
        this.$message.error("请输入被询问人年龄");
      } else if (!this.form.recordPO.respondentNation) {
        this.$message.error("请输入被询问人民族");
      } else if (!this.form.recordPO.respondentGender) {
        this.$message.error("请选择被询问人性别");
      } else if (!this.form.recordPO.respondentEdu) {
        this.$message.error("请选择被询问人学历");
      } else if (!this.form.recordPO.respondTimes) {
        this.$message.error("请选择被询问人询问次数");
      } else if (!this.form.recordPO.respondentType) {
        this.$message.error("请选择被询问人类型");
      } else if (
        !this.form.recordPO.respondentPhone ||
        !telrule.test(this.form.recordPO.respondentPhone)
      ) {
        this.$message.error("请输入正确的手机号");
      } else if (!this.form.recordPO.respondentCertType) {
        this.$message.error("请选择证件类型");
      } else if (
        !this.form.recordPO.respondentCertNo ||
        !regIdCard.test(this.form.recordPO.respondentCertNo)
      ) {
        this.$message.error("请输入正确的身份证号");
      } else if (!this.form.recordPO.respondentOrigin) {
        this.$message.error("请输入被询问人户籍地");
      } else if (!this.form.recordPO.respondentAddress) {
        this.$message.error("请输入被询问人现居地");
      } else {
        if (val == 'save') {
          changerecord([localStorage.getItem("caseid"), this.form]).then(res => {
            // console.log(this.form.recordPO.status);
            if (res && res.code === 200) {
              this.$message.success("笔录保存成功");
              // if (this.form.recordPO.status === 2) {
              //   window.location.href = "/record/ask";
              // }

            }
          });
        } else {
          if (this.flag === true) {
            previewpdf([localStorage.getItem("caseid")]).then(res => {
              if (res && res.code === 200) {
                window.open("https://videoapi.terabits.cn" + res.data);
                this.flag = false;
              }
            });
          }
        }

      }
    },
    finishrecord() {

      console.log('结束笔录');
      changerecord([localStorage.getItem("caseid"), this.form]).then(res => {
        // console.log(this.form.recordPO.status);
        if (res && res.code === 200) {
          // this.$message.success("笔录保存成功");
          setFinishrecord(localStorage.getItem("caseid"), this.form).then(res => {
            if (res && res.code === 200) {
              this.$message.success("该笔录结束");
              window.location.href = "/record/ask"
              // this.$router.push('/record/ask')
              // if (this.form.recordPO.status === 2) {
              //   window.location.href = "/askmanage";
              // }
              // if (this.flag === true) {
              //   previewpdf([localStorage.getItem("caseid")]).then(res => {
              //     if (res && res.code === 200) {
              //       window.open("https://ivatest.terabits.cn" + res.data);
              //       this.flag = false;
              //     }
              //   });
              // }
            }
          })


        }
      })

    },

    //点击结束
    endrecord() {
      if (this.enddis === false) {
        return this.$message.error('笔录视频未保存，请保存视频')
      } else {
        this.form.recordPO.status = 2;
        this.form.recordPO.inquiryEnd = this.$moment(new Date()).format(
          "yyyy-MM-DD HH:mm:ss"
        );
        this.$confirm("您确定要结束该案件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          callback: action => {
            if (action === "confirm") {
              this.finishrecord();
            }
          }
        });
      }

    },

    //点击删除
    deletebutton(item) {
      this.$confirm("确认要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // console.log(item);
          // console.log(item.id);
          // console.log(this.askForm.askList);
          let arr = [];
          this.casedeid = item.sort;
          for (let i in this.form.questions) {
            if (this.form.questions[i].sort !== this.casedeid) {
              arr.push(this.form.questions[i]);
            }
          }
          // console.log(arr);
          this.form.questions = arr;
          // this.askForm.askList = arr;
        })
        .catch(() => { });
    },
    //点击新增
    addbutton(item) {
      console.log(item);
      console.log(this.form.questions);
      for (var i in this.form.questions) {
        if (this.form.questions[i].sort > item.sort) {
          this.form.questions[i].sort = this.form.questions[i].sort + 1;
        }
      }
      this.form.questions.push({
        content: "",
        answer: "",
        sort: item.sort + 1
      });
      console.log(this.form.questions);
      this.form.questions = this.form.questions.sort(function (a, b) {
        return a.sort - b.sort
      });

      // this.aform.questions.sort(function (a, b) {
      //   return a.sort < b.sort ? -1 : 1;
      // });

      // console.log(this.askForm.askList);
    },
    timeFunction() {
      // 开始执行倒计时
      this.timeObj = {
        // 时间对象
        seconds: Math.floor(this.currentTime % 60),
        minutes: Math.floor(this.currentTime / 60) % 60,
        hours: Math.floor(this.currentTime / 60 / 60) % 24
      };
      // 计算出时分秒
      this.myHours =
        this.timeObj.hours < 10 ? "0" + this.timeObj.hours : this.timeObj.hours;
      this.myMinutes =
        this.timeObj.minutes < 10
          ? "0" + this.timeObj.minutes
          : this.timeObj.minutes;
      this.mySeconds =
        this.timeObj.seconds < 10
          ? "0" + this.timeObj.seconds
          : this.timeObj.seconds;
      this.currentTime++;
    },
    recordlist() {
      findrecord([localStorage.getItem("caseid")]).then(res => {
        // console.log(res.data);
        if (res && res.code === 200) {
          // console.log(111);
          // console.log(res.data.recordPO.inquiryScene);
          this.form = res.data;
          this.form.recordPO.videoUrl = this.form.recordPO.videoUrl
            ? this.form.recordPO.videoUrl
            : null;
          this.form.recordPO.respondTimes = this.form.recordPO.respondTimes
            ? this.form.recordPO.respondTimes
            : 1;
          this.form.recordPO.respondentEdu = this.form.recordPO.respondentEdu
            ? this.form.recordPO.respondentEdu
            : "本科";
          this.form.recordPO.respondentNation = this.form.recordPO
            .respondentNation
            ? this.form.recordPO.respondentNation
            : "汉族";

          this.form.recordPO.inquiryBegin
            ? this.form.recordPO.inquiryBegin
            : this.$moment(new Date()).format("yyyy-MM-DD HH:mm:ss");

          if (this.$route.query.copy === 'true' && localStorage.getItem('copyquestions')) {
            const copyquestions = JSON.parse(this.$Base64.decode(localStorage.getItem('copyquestions')))
            // this.form.questions = copyquestions
            this.form.questions = copyquestions
            this.form.questions.map(el => {
              el.answer = ''
            })
            // this.form.questions = this.
          } else {
            this.form.questions = res.data.questions.sort(function (a, b) {
              return a.sort < b.sort ? -1 : 1;
            });
          }
          this.datalist = res.data;

          // console.log(this.tableData);
        }
      });

    },

    //开始录制
    beginrecord() {
      // console.log(111);
      // console.log(this.$refs.video.roomId);
      const params = {
        recordId: localStorage.getItem("caseid"),
        tag: this.form.recordPO.caseName,
        roomId: this.$refs.video.roomId
      };
      startrecording(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success("开始录制");
          this.begdis = true;
          this.enddis = false;
        }
      });
    },

    //时间展示
    time() {
      let nowtime = new Date();
      let year = nowtime.getFullYear();
      let month = nowtime.getMonth() + 1;
      let date = nowtime.getDate();
      this.innerText =
        year +
        "年" +
        month +
        "月" +
        date +
        "日 " +
        nowtime.toLocaleTimeString();
      setInterval(this.showTime, 1000);
    },

    showTime() {
      let nowtime = new Date();
      let year = nowtime.getFullYear();
      let month = nowtime.getMonth() + 1;
      let date = nowtime.getDate();
      this.innerText =
        year +
        "年" +
        month +
        "月" +
        date +
        "日 " +
        nowtime.toLocaleTimeString();
    },

    //打开关闭左边菜单
    openmenu() {
      this.isCollapse = !this.isCollapse;
      this.$emit("getShopCode", this.isCollapse);
      // this.$router.push({ name: "askdetail" });
    },

    //结束录制
    endrecords() {
      console.log(111);
      console.log(this.$refs.video.roomId);
      const params = {
        roomId: this.$refs.video.roomId
      };
      stoprecording(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success("结束录制");
          this.begdis = false;
          this.enddis = true;
          this.endType = true;
        }
      });
    },
    // 展示/隐藏开始结束录制按钮
    showButton(val) {
      // console.log('val :>> ', val);
      if (val) {
        this.showbtn = true;
      } else {
        this.showbtn = false;
      }
    },
    handleChange() { }
  },
  mounted() {
    // 拖拽后触发的事件
    this.$dragging.$on("dragged", res => {
      console.log(res);
    });
  },
  created() {
    // console.log(this.myHours);
    this.recordlist();
    this.testTimer();
    this.time();
  }
};
</script>

<style scoped>
.adddelimg {
  height: 30px;
  width: 30px;
}

.deletebtn {
  background: white;
  border: 1px solid #ff405c;
  color: #ff405c;
}

.deletebtn:hover {
  background: #ff405c;
  border: 1px solid #ff405c;
  color: white;
}

.deletebtn:focus {
  background: #ff405c;
  border: 1px solid #ff405c;
  color: white;
}

.addbtn {
  background: white;
  border: 1px solid #3370ff;
  color: #3370ff;
}

.askqueline {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding-right: 10px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.askqueline .el-form-item {
  flex: 1;
  display: flex;
  align-items: center;
}

::v-deep .el-form-item__label {
  padding: 0;
}

::v-deep .askqueline .el-form-item .el-form-item__content {
  flex: 1;
  margin-right: 10px;
}

::v-deep .el-button--primary.is-disabled {
  background-color: #999;
  border-color: #999;
}

::v-deep .is-active i {
  color: #666666;
}

.asktype {
  width: 30px;
  height: 30px;
  color: white;
  background: #ffa700;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
  position: relative;
}

.quetype {
  width: 30px;
  height: 30px;
  color: white;
  background: #00bea5;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
  position: relative;
}

.toupimg {
  position: absolute;
  width: 10px;
  height: 10px;
  left: 28px;
  cursor: pointer;
}

.todownimg {
  position: absolute;
  width: 10px;
  height: 10px;
  left: 28px;
  bottom: 0;
  cursor: pointer;
}

.drag-content {
  width: 100%;
  text-align: left;
}

/* .drag-content span {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
} */

.beginvideo {
  color: white;
  border-radius: 5px;
  background: #3370ff;
  border: 1px solid #3370ff;
}

.endvideo {
  color: white;
  border-radius: 5px;
  background: #999999;
  border: 1px solid #999999;
  font-size: 14px;
}

.videomain {
  /* border-bottom: 1px solid #3370ff; */
  height: 350px;
  /* position: absolute;
  left: 20px;
  top: 20px; */
}

.qarecord {
  font-size: 18px;
  font-weight: bold;
  color: #222426;
  text-align: left;
  display: flex;
  align-items: center;
  /* position: absolute;
  left: 20px;
  top: 20px; */
}

.tip {
  height: 43px;
  background: #fdebca;
  border-radius: 5px;
  display: inline-block;
  color: #ffa700;
  font-size: 16px;
  display: flex;
  align-items: center;
  width: 80px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  justify-content: space-around;
  font-weight: bold;
  margin-left: 20px;
}

.tipimg {
  width: 20px;
  height: 20px;
}

.askcontainer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 20px;
}

.askmain {
  border: 1px solid #e8e8e8;
  width: 185px;
  font-size: 14px;
  text-align: left;
}

.askheader {
  height: 36px;
  display: flex;
  align-items: center;
  padding-left: 12px;
  font-size: 14px;
  border-bottom: 1px solid #e8e8e8;
}

.askline {
  line-height: 36px;
  padding-left: 12px;
}

.titlewidths {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.titlewidthr {
  display: inline-block;
  width: 130px;
  text-align: right;
}

.titlewidth {
  display: inline-block;
  width: 120px;
  text-align: right;
}

.dian {
  color: #ff405c;
  vertical-align: sub;
  margin-right: 5px;
}

.contentkey {
  font-size: 16px;
  color: #666666;
  width: 100px;
  display: inline-block;
}

.timeimg {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}

.headermid {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #3370ff;
}

.titlefront {
  font-weight: normal;
  font-size: 14px;
  margin-left: 10px;
}

.headermain {
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 20px;
  box-sizing: border-box;
}

.headerleft {
  font-size: 18px;
  color: #222426;
  font-weight: bold;
}

.bodycontainer {
  margin-top: 20px;
}

.bodyleft {
  height: 700px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
  overflow-y: scroll;
}

.bodyright {
  margin-left: 20px;
  height: 700px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  border-radius: 3px;
}

.askcontenthead {
  height: 370px;
  padding: 20px;
  padding-bottom: 0;
}

.askcontentmain {
  padding-left: 20px;
  height: 630px;
  overflow-y: scroll;
}

::v-deep .askcontentmain .el-form .qaBox:last-child {
  margin-right: 26px;
}

.bodyleftheader {
  height: 48px;
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #cacaca;
  padding-left: 20px;
}

.duihua {
  display: flex;
  align-items: center;
}

.bodyrightheader {
  height: 60px;
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #cacaca;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: bold;
  font-size: 18px;
  justify-content: space-between;
}

.contenttitle {
  color: #3370ff;
  font-size: 18px;
  font-weight: bold;
  height: 48px;
  display: inline-block;
  line-height: 50px;
  border-bottom: 3px solid #3370ff;
}

.contline {
  margin-top: 20px;
  padding-left: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 20px;
  box-sizing: border-box;
}
</style>
